import { render, staticRenderFns } from "./InfoTablePreferential.vue?vue&type=template&id=ae5be894&scoped=true"
import script from "./InfoTablePreferential.vue?vue&type=script&lang=js"
export * from "./InfoTablePreferential.vue?vue&type=script&lang=js"
import style0 from "./InfoTablePreferential.vue?vue&type=style&index=0&id=ae5be894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5be894",
  null
  
)

export default component.exports